import { useEffect, useState } from "react";

import { LoadingState } from "@/components/DashboardParts";
import AdminTrainerFeedbackReport from "@/components/AdminTrainerFeedbackReport";
import RoleLayout from "@/components/RoleLayout";
import BatchAttendanceReport from "@/components/BatchAttendanceReport";
import TrainerAttendanceReport from "@/components/TrainerAttendanceReport";
import { api } from "@/lib/api";

export default function AdminReportsPage() {
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [centers, setCenters] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/lms/reports"), api.get("/lms/training-centers")])
      .then(([reportData, centerData]) => {
        setReport(reportData.data);
        setCenters(centerData.data);
      })
      .catch(() => setError("Reports could not be loaded."));
  }, []);

  if (error) {
    return (
      <RoleLayout eyebrow="Administrator workspace" title="Reports">
        <p className="form-error" data-testid="reports-error">{error}</p>
      </RoleLayout>
    );
  }
  const downloadManual = async () => {
    setIsDownloading(true);
    try {
      const response = await api.get("/lms/reports/user-manual", { responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Skillexpress_User_Manual.pdf";
      link.click();
      URL.revokeObjectURL(url);
    } finally {
      setIsDownloading(false);
    }
  };

  if (!report) {
    return <LoadingState label="Loading reports" />;
  }

  const items = [
    ["Courses", report.metrics.courses],
    ["Trainers", report.metrics.trainers],
    ["Learners", report.metrics.learners],
    ["Average completion", `${report.metrics.completion}%`],
  ];

  return (
    <RoleLayout eyebrow="Administrator workspace" title="Reports">
      <section className="section-heading">
        <div>
          <p className="eyebrow">Common reports</p>
          <h2>Training performance</h2>
        </div>
        <button
          className="outline-button"
          onClick={downloadManual}
          disabled={isDownloading}
          data-testid="download-user-manual-button"
        >
          {isDownloading ? "Preparing manual" : "Download user manual"}
        </button>
      </section>
      <section className="report-grid" data-testid="reports-metric-grid">
        {items.map(([label, value]) => (
          <article key={label}>
            <span>{label}</span>
            <strong>{value}</strong>
            <small>Current workspace</small>
          </article>
        ))}
      </section>
      <AdminTrainerFeedbackReport centers={centers} />
      <TrainerAttendanceReport centers={centers} />
      <BatchAttendanceReport batches={report.batches} />
    </RoleLayout>
  );
}